<template>
  <div>
    <CRow class="content-fade-in">
      <CCol md="12">
        <CCard>
          <CCardBody>
            <CForm class="form-basic">
              <CRow>
                <CCol sm="6" md="6" xl="6">
                  <BaseInput :options="codeInput.options" :data="codeInput.data"/>
                </CCol>
                <CCol sm="6" md="6" xl="6">
                  <BaseInput :options="nameInput.options" :data="nameInput.data"/>
                </CCol>
                <CCol sm="6" md="6" xl="6">
                  <BaseInput :options="urlInput.options" :data="urlInput.data"/>
                </CCol>
                <CCol sm="6" md="6" xl="6">
                  <BaseInput :options="descriptionInput.options" :data="descriptionInput.data"/>
                </CCol>
                <CCol sm="6" md="6" xl="6">
                  <BaseInput :options="clientIdInput.options" :data="clientIdInput.data"/>
                </CCol>
                <CCol xs="12" sm="12" md="6" lg="6" xl="6">
                  <BaseSelect :options="statusSelect.options" :data="statusSelect.data"
                              ref="statusSelect"></BaseSelect>
                </CCol>
              </CRow>
              <div slot="footer" class="mt-4">
                <CButton
                  color="primary"
                  class="btn-action-primary mr-2"
                  @click="submitData"
                >
                  <i class="fa fa-refresh"></i> Cập nhật
                </CButton
                >
                <CButton
                  color="secondary"
                  class="btn-action-primary"
                  @click="$router.go(-1)"
                ><i class="fa fa-reply"></i> Hủy bỏ
                </CButton>
              </div>
              <BaseLoading :loading="loading.value"></BaseLoading>
            </CForm>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import BaseSelect from "../base/BaseSelect2";
import BaseInput from "../base/BaseInput";
import BaseLoading from "../base/BaseFormLoading";

export default {
  name: "SystemUpdate",
  components: {BaseSelect, BaseInput, BaseLoading},
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success"
    },
    showErrorMsg: {
      type: "error",
      title: "Errors"
    },
    showWarningMsg: {
      type: "warn",
      title: "warn"
    }
  },
  data: function () {
    let that = this;
    return {
      loading: {value: false},
      idField: {
        data: {
          model: that.$route.params.id,
          name: "id"
        }
      },
      codeInput: {
        options: {
          label: "Mã hệ thống <span class='required'>*</span>",
          placeholder: "Mã hệ thống",
          maxlength: 45,
          disabled: true
        },
        data: {
          name: "code",
          model: "",
          updateCallback: function () {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.codeInput.data.model;
              if (value === "") {
                this.isValid = false;
                this.errorMessage = "Mã hệ thống không được để trống";
              } else {
                this.isValid = true;
              }
              return this.isValid;
            }
          }
        }
      },
      nameInput: {
        options: {
          label: "Tên hệ thống <span class='required'>*</span>",
          placeholder: "Tên hệ thống",
          maxlength: 128
        },
        data: {
          name: "name",
          model: "",
          updateCallback: function () {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.nameInput.data.model;
              if (value === "") {
                this.isValid = false;
                this.errorMessage = "Tên hệ thống không được để trống";
              } else {
                this.isValid = true;
              }
              return this.isValid;
            }
          }
        }
      },
      urlInput: {
        options: {
          label: "URL <span class='required'>*</span>",
          placeholder: "URL",
          maxlength: 256
        },
        data: {
          name: "url",
          model: "",
          updateCallback: function () {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.urlInput.data.model;
              if (value === "") {
                this.isValid = false;
                this.errorMessage = "URL không được để trống";
              } else {
                this.isValid = true;
              }
              return this.isValid;
            }
          }
        }
      },
      clientIdInput: {
        options: {
          label: "Client ID <span class='required'>*</span>",
          placeholder: "Client ID",
          maxlength: 256
        },
        data: {
          name: "clientId",
          model: "",
          updateCallback: function () {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.clientIdInput.data.model;
              if (value === "") {
                this.isValid = false;
                this.errorMessage = "Client ID không được để trống";
              } else {
                this.isValid = true;
              }
              return this.isValid;
            }
          }
        }
      },
      descriptionInput: {
        options: {
          label: "Mô tả hệ thống <span class='required'>*</span>",
          placeholder: "Mô tả hệ thống",
          maxlength: 256
        },
        data: {
          name: "description",
          model: "",
          updateCallback: function () {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.descriptionInput.data.model;
              if (value === "") {
                this.isValid = false;
                this.errorMessage = "Mô tả hệ thống không được để trống";
              } else {
                this.isValid = true;
              }
              return this.isValid;
            }
          }
        }
      },
      statusSelect: {
        options: {
          filter: false,
          label: 'Trạng thái',
        },
        data: {
          name: "status",
          items: [
            // {key: "null", value: "Tất cả trạng thái"},
            {key: "1", value: "Hoạt động"},
            {key: "0", value: "Không hoạt động"},
          ],
          model: "1",
          updateCallback: function () {
            that.submitData();
          },
        }
      },
    }
  },
  methods: {
    submitData: function () {
      let that = this;
      this.$helper.loadDataSource({
        loading: that.loading,
        url: "/system/update",
        dataRef: function () {
          return that.$data;
        },
        successCallback: function (response) {
          if (!that.$helper.validResponse(that.$router, response.data)) {
            that.showErrorMsg({message: that.$helper.getStringError(response.data.data)});
            that.$helper.setupErrorModel(response.data.data, that.$data);
          } else {
            that.showSuccessMsg({
              message: "Cập nhật hệ thống thành công"
            });
            that.$router.go(-1);
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    },
    loadData: function () {
      let that = this;
      that.loading.value = true
      this.$helper.loadDataSource({
        loading: that.loading,
        url: "/system/findById",
        isJsonContentType: false,
        dataSubmit: function () {
          return {id: that.idField.data.model}
        },
        successCallback: function (response) {
          that.dataCache = response.data.data;
          that.$helper.setupDataResponse(that.$data, response.data.data);
          that.loading.value = false
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
          that.loading.value = false
        }
      });
    },

  },
  computed: {},
  created() {
  },
  mounted() {
      this.loadData();
  },
  watch: {

  }
};
</script>
